import BaseModelAPI from '../BaseModelAPI';

export default class DocumentType extends BaseModelAPI {
	static entity = 'documenttype';
	static entityName = 'documenttype';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}